export { default as DiscountBadge } from './DiscountBadge';
export { DiscountBadgeVariant } from './DiscountBadge.interfaces';
